import { IRestfulApiService } from '@/lib/apiService'
import {
	AddItemToCartDTO,
	AddItemToCartResponseDTO,
	IMutationCommand,
} from '@bookips/solvook-api-shared'

export class AddItemToCartCommand
	implements IMutationCommand<any, AddItemToCartDTO, AddItemToCartResponseDTO>
{
	private apiService: IRestfulApiService

	constructor(apiService: IRestfulApiService) {
		this.apiService = apiService
	}

	execute(_, dto: AddItemToCartDTO): Promise<AddItemToCartResponseDTO> {
		const url = `/carts/current/items`

		return this.apiService
			.fetch<AddItemToCartResponseDTO>(url, { method: 'POST', data: dto })
			.then((res) => res.data)
	}
}
